<template>

  <div class="d-flex mt-4 ga-4 flex-grow-1 min-h-0">
    <div class="gm-card product-model-tabs-card flex-shrink-0" style="width: 200px;">
      <v-tabs v-model="activeTab" direction="vertical" color="var(--color-primary)">
        <v-tab value="cluster" :prepend-icon="Brackets">电池簇</v-tab>
        <v-tab value="eBlock" :prepend-icon="Box">能量块</v-tab>
        <v-tab value="meter" :prepend-icon="Gauge">电表</v-tab>
        <v-tab value="pv" :prepend-icon="Sun">光伏</v-tab>
        <v-tab value="conditioner" :prepend-icon="Droplets">水机</v-tab>
        <v-tab value="chargingPile" :prepend-icon="BatteryCharging">充电桩</v-tab>
        <v-tab value="pcs" :prepend-icon="Zap">PCS</v-tab>
      </v-tabs>
    </div>

    <div class="flex-grow-1 gm-card product-model-content min-h-0 d-flex flex-column overflow-hidden">
      <component :is="currentComponent" class="flex-grow-1 min-h-0 d-flex flex-column" />
    </div>
  </div>

</template>


<script setup>
import { ref, computed } from 'vue'
import { Brackets, Box, Gauge, Sun, Droplets, BatteryCharging, Zap } from 'lucide-vue-next'
import Cluster from './Cluster/index.vue'
import Meter from './Meter/index.vue'
import EBlock from './EBlock/index.vue'
import Conditioner from './Conditioner/index.vue'
import PV from './PV/index.vue'
import ChargingPile from './ChargingPile/index.vue'
import PCS from './PCS/index.vue'

const Components = {
  cluster: Cluster,
  meter: Meter,
  eBlock: EBlock,
  conditioner: Conditioner,
  pv: PV,
  chargingPile: ChargingPile,
  pcs: PCS,
}

const activeTab = ref('cluster')
const currentComponent = computed(() => Components[activeTab.value])


</script>

<style scoped lang="scss">
.product-model-content,
.product-model-tabs-card {
  background: #fff !important;
}

.product-model-content {
  border-radius: 0 30px 30px 0;
}
</style>
